import React from "react";
import { Helmet } from "react-helmet-async";
import InnerBanner from "../components/InnerBanner";
import serviceBg from "../assets/hero3.png";
import "./BrandService.css";

const WashingMachineService = () => {
  return (
    <>
      {/* ✅ SEO */}
      <Helmet>
        <title>Washing Machine Service & Repair Center in Bangalore</title>
        <meta
          name="description"
          content="Affordable washing machine service in Bangalore. Expert repair for all brands with doorstep support and genuine spare parts."
        />
        <meta
          name="keywords"
          content="washing machine service Bangalore, washing machine repair Bangalore,  washing machine repair in bangalore"
        />
        <meta property="og:title" content="Washing Machine Service & Repair Center in Bangalore" />
        <meta
          property="og:description"
          content="Affordable washing machine service in Bangalore. Expert repair for all brands with doorstep support and genuine spare parts."
        />
        <meta property="og:image" content="https://customersupports24x7.in/customerSupport.png" />
        <meta property="og:url" content="https://customersupports24x7.in/washing-machine-service-bangalore" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Washing Machine Service & Repair Center in Bangalore" />
        <meta
          name="twitter:description"
          content="Affordable washing machine service in Bangalore. Expert repair for all brands with doorstep support and genuine spare parts."
        />
        <meta name="twitter:image" content="https://customersupports24x7.in/customerSupport.png" />
        <link rel="canonical" href="https://customersupports24x7.in/washing-machine-service-bangalore" />
      </Helmet>

      {/* ✅ BANNER */}
      <div className="brand-service-banner">
        <InnerBanner
          title="Washing Machine Service in Bangalore"
          bgImage={serviceBg}
        />
      </div>

      <div className="brand-service-page service-page">

        {/* INTRO */}
        <p style={{ textAlign: 'justify' }}>
        Searching for trusted <span style={{ fontWeight: 'bold' }}>washing machine service center in Bangalore</span>? Customer Supports 24x7 provides professional doorstep repair services without the hassle of visiting a physical service center. Our goal is to bring fast, reliable, and affordable solutions directly to your home.
        </p>

        <p style={{ textAlign: 'justify' }}>
         We understand how important your washing machine is in daily life. That's why our technicians are trained to handle all brands and models, including front load, top load, and fully automatic machines.
        </p>

        {/* SERVICE SOLUTIONS */}
        <div className="card">
          <h2>Our Service Center Solutions Include</h2>
          <ul style={{ textAlign: 'justify' }}>
            <li>Complete inspection and fault diagnosis</li>
            <li>Repair of electrical and mechanical components</li>
            <li>Replacement of damaged parts with genuine spares</li>
            <li>Regular maintenance and servicing</li>
            <li>Installation services for new machines</li>
          </ul>
        </div>

        {/* COMMON ISSUES */}
        <div className="card">
          <h2>Common Issues We Fix</h2>
          <ul style={{ textAlign: 'justify' }}>
            <li>Machine not starting or working properly</li>
            <li>Water leakage and drainage problems</li>
            <li>Spin issues and noise problems</li>
            <li>Door lock and latch failures</li>
            <li>Drum and motor issues</li>
            <li>PCB and sensor malfunctions</li>
          </ul>
        </div>

        {/* FRONT LOAD SECTION */}
        <div className="card">
          <h2>Front Load Washing Machine Service</h2>

          <p style={{ textAlign: 'justify' }}>
            Looking for reliable <span style={{ fontWeight: 'bold' }}>front load washing machine service in Bangalore</span>?
            We provide expert repair and maintenance solutions for all front load
            models with advanced diagnostics and quick service.
          </p>

          <p style={{ textAlign: 'justify' }}>
            Front load machines are known for efficiency but require professional
            handling when issues arise. Our trained technicians ensure precise
            repairs and long-lasting performance.
          </p>

          <h3>Services Offered</h3>
          <ul style={{ textAlign: 'justify' }}>
            <li>Drum and motor repair</li>
            <li>PCB and sensor issues</li>
            <li>Water leakage and drainage repair</li>
            <li>Installation and maintenance</li>
            <li>Bearing and seal replacement</li>
          </ul>

          <h3>Common Front Load Issues</h3>
          <ul style={{ textAlign: 'justify' }}>
            <li>Not spinning</li>
            <li>Excess vibration</li>
            <li>Water not draining</li>
            <li>Door not opening/closing</li>
          </ul>
        </div>

        {/* TOP LOAD SECTION */}
        <div className="card">
          <h2>Top Load Washing Machine Service</h2>

          <p style={{ textAlign: 'justify' }}>
            Our technicians specialize in <span style={{ fontWeight: 'bold' }}>top load washing machine repair services</span> for all major brands. We provide efficient and cost-effective solutions.
          </p>

          <h3>Services Offered</h3>
          <ul style={{ textAlign: 'justify' }}>
            <li>Agitator and impeller repair</li>
            <li>Motor and pump replacement</li>
            <li>Water inlet valve issues</li>
            <li>Control panel and timer repairs</li>
            <li>Fill and drain problems</li>
          </ul>

          <h3>Common Top Load Issues</h3>
          <ul style={{ textAlign: 'justify' }}>
            <li>Water not filling</li>
            <li>Water not draining properly</li>
            <li>Clothes not getting cleaned</li>
            <li>Excessive vibration during spin cycle</li>
          </ul>
        </div>

        {/* WHY CHOOSE */}
        <div className="card">
          <h2>Why Choose Our Service?</h2>
          <ul style={{ textAlign: 'justify' }}>
            <li>✔ Experienced technicians for all brands</li>
            <li>✔ Same-day service availability</li>
            <li>✔ Genuine spare parts guarantee</li>
            <li>✔ Affordable service charges</li>
            <li>✔ Warranty on parts and labor</li>
          </ul>
        </div>

        {/* CTA */}
        <div className="cta-box">
          <h3>Book Service Today</h3>
          <p style={{ color: '#ffffff', textAlign: 'center', fontSize: '18px' }}>
            Skip long queues at service centers—call now and get expert service
            at your doorstep anywhere in Bangalore.
          </p>

          <a href="tel:8050731754">
            <button className="call-btn">📞 Call Now</button>
          </a>
        </div>

      </div>
    </>
  );
};

export default WashingMachineService;

